module.exports = __webpack_public_path__ + "static/img/img-vespa-piaggio.1f02780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-vespa-piaggio.png
// module id = ss8b
// module chunks = 36